import * as React from "react";

import { styled } from "../../../styled-components";

const SeeAllButtonStyle = styled.button`
    ${p => p.theme.fontStyles.Subheader5};
    color: ${p => p.theme.primaryAccentColor};
    display: "flex";
    white-space: "nowrap";
`;

const SeeAllButton: React.FunctionComponent<React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
>> = p => {
    const { children, ref, key, ...rest } = p;
    return (
        <SeeAllButtonStyle {...rest} data-test="see-all">
            {p.children}
        </SeeAllButtonStyle>
    );
};

export default SeeAllButton;
